export const de = {
  "save": "Speichern",
  "update": "Aktualisieren",
  "accept": "Annehmen",
  "cancel": "Abbrechen",
  "close": "Schließen",
  "add": "Hinzufügen",
  "check": "Prüfen",
  "certificate": "Zertifikat",
  "certificates": "Zertifikate",
  "certification": "Zertifizierung",
  "certifications": "Zertifizierungen",
  "valid-certificate": "Gültiges Zertifikat",
  "date": "Datum",
  "valid-thru": "Gültig bis",
  "dashboard": "Startseite",
  "error": "Fehlerseite",
  "forms": "Formulare",
  "notifications": "Benachrichtigungen",
  "my-profile": "Mein Profil",
  "my-documents": "Meine Unterlagen",
  "no-documents-available": "Keine Unterlagen verfügbar",
  "training-materials": "Schulungsunterlagen",
  "open-in-webviewer": "Im Viewer öffnen",
  "expired": "Abgelaufen",
  "expired-training-materials": "Abgelaufene Schulungsunterlagen",
  "register-headline": "Registrierung",
  "register": "Registrieren",
  "search": "Suche",
  "print": "Drucken",
  "printed-via": "Gedruckt über www.evalcard.com",
  "settings": {
    "label": "Einstellungen",
    "publicProfile": {
      "showEmailInPublic": "E-Mail anzeigen",
      "showPhoneInPublic": "Telefonnummer anzeigen",
      "showAddressInPublic": "Adresse anzeigen"
    }
  },
  "tables": "Tabellen",
  "tabs": "Tabs",
  "myeval": "EvalCard",
  "eval-id": "Eval-ID",
  "id": "ID",
  "timeline": "Timeline",
  "typography": "Typographie",
  "admin": "Administrator",
  "user": "Benutzer",
  "templateAuthor": "Globaler Vorlagenersteller",
  "users": "Benutzer",
  "user-profile": "Benutzerprofil",
  "company-name": "Firmenname",
  "company-logo": "Firmenlogo",
  "company-profile": "Firmenprofil",
  "company-profile-admin": "Firmenprofil",
  "company-invitation": "Firmeneinladung",
  "invitation-sent": "Einladung versendet",
  "new-password": "Neues Passwort",
  "generate-new-password": "Neues Passwort generieren",
  "current-password": "Derzeitiges Passwort",
  "repeat-password": "Passwort wiederholen",
  "password-successfully-changed": "Ihr Passwort wurde erfolgreich geändert",
  "password-reset": "Passwort zurücksetzen",
  "edit-user-profile": "Benutzerprofil bearbeiten",
  "edit-user-profile-admin": "Benutzerprofil bearbeiten",
  "system": "System",
  "widgets": "Widgets",
  "wizard": "Wizard",
  "logout": "Ausloggen",
  "login": "Anmelden",
  "companies": "Firmen",
  "my-company": "Meine Firma",
  "leave-company": "Firma verlassen",
  "delete-company": "Firma löschen",
  "company": "Firma",
  "uid": "UID/Steuernummer",
  "employees": "Angestellte",
  "employee": "Mitarbeiter/in",
  "companyadmin": "Admin",
  "evalclient": "EVAL Beauftragter",
  "coworker": "Mitarbeiter",
  "coworker-profile": "Mitarbeiterprofil",
  "search-user": "Benutzer suchen",
  "search-user-placeholder": "Name, E-Mail, EVAL-ID",
  "trainer": "Trainer",
  "training-level": "Ausbildungsstufe",
  "gtp": "GTP",
  "authorityAdmin": "Admin",
  "trainerRO": "Trainer (Nur Lesen)",
  "authorityAdminRO": "Admin (Nur Lesen)",
  "protocols": "Prüfberichte",
  "report": "Prüfbericht",
  "new-report": "Neuer Prüfbericht",
  "all-reports": "Alle Prüfberichte",
  "all-assets": "Alle Objekte",
  "report-from": "Prüfbericht vom",
  "report-details": "Prüfberichtdetails",
  "data": "Daten",
  "info": "Infos",
  "attachment": "Anhang",
  "contact": "Kontakt",
  "continue": "Weiter",
  "start": "Starten",
  "summary": "Zusammenfassung",
  "vin": "VIN",
  "licence-plate": "Kennzeichen",
  "owner": "Besitzer",
  "vehicles": "Fahrzeuge",
  "vehicle": "Fahrzeug",
  "vehicle-details": "Fahrzeugdetails",
  "companyVehicle": "Firmenfahrzeug",
  "valid": "In Ordnung",
  "invalid": "Nicht in Ordnung",
  "tester": "Prüfer",
  "vehicles-admin": "Fahrzeuge",
  "create-company-vehicle": "Fahrzeug anlegen",
  "select-vehicle": "Fahrzeugauswahl",
  "my-vehicles": "Meine Fahrzeuge",
  "my-vehicle": "Mein Fahrzeug",
  "asset": "Objekt",
  "assets": "Objekte",
  "serial-number": "Seriennummer",
  "asset-type": "Objekttyp",
  "asset-types": "Objekttypen",
  "calibration-valid-thru": "Kalibrierung gültig bis",
  "requires-calibration": "Muss regelmäßig kalibriert werden",
  "calibration-warning-days": "Warnfrist (Tage)",
  "gtp-classes": "GTP-Klassen",
  "code": "Code",
  "subtype": "Untertyp",
  "icon": "Icon",
  "qualification": "Qualifikation (HTML)",
  "gtpIcon": {
    "car": "Auto",
    "forklift": "Gabelstapler",
    "gauge": "Tacho",
    "train-front": "Zug",
    "ship": "Schiff",
    "plane": "Flugzeug",
    "settings": "Zahnrad",
    "wrench": "Schraubenschlüssel"
  },
  "photos": "Fotos",
  "new-vehicle": "Neues Fahrzeug",
  "manufacturer": "Hersteller",
  "no-manufacturer": "(Kein Hersteller)",
  "no-vehicle": "(Kein Fahrzeug)",
  "vehicle-manufacturer": "Fahrzeughersteller",
  "create-vehicle": "Fahrzeug anlegen",
  "create-vehicle-manufacturer": "Fahrzeughersteller anlegen",
  "construction-year": "Baujahr",
  "change-password": "Passwort ändern",
  "roles": "Berechtigungen",
  "actions": "Aktionen",
  "action": "Aktion",
  "profile": "Profil",
  "email": "E-Mail",
  "basic": "Basis",
  "special": "Spezial",
  "breakdown": "Aufteilung",
  "click-for-details": "Klicken für Details",
  "rights": "Rechte",
  "details": "Details",
  "information": "Informationen",
  "details-and-information": "Details & Informationen",
  "name": "Name",
  "namename": "Bezeichnung",
  "firstname": "Vorname",
  "lastname": "Nachname",
  "fullname": "Voller Name",
  "password": "Passwort",
  "street": "Straße",
  "number": "Nummer",
  "city": "Stadt",
  "country": "Land",
  "forgot-password": "Passwort vergessen?",
  "recover-password": "Passwort zurücksetzen",
  "back": "Zurück",
  "back-to-login": "Zurück zum Login",
  "go-to-login": "Zum Login",
  "choose-picture": "Bild auswählen",
  "choose-logo": "Logo auswählen",
  "image-format-not-supported": "Dieses Bildformat wird nicht unterstützt. Bitte ein JPG- oder PNG-Bild wählen.",
  "send-invitation": "Einladung senden",
  "zipcode": "PLZ",
  "previous": "Zurück",
  "abort": "Abbrechen",
  "i-understand": "Verstanden",
  "no": "Nein",
  "yes": "Ja",
  "inputs": "Eingaben",
  "user-activated": "Aktiviert",
  "user-not-activated": "Benutzer ist noch nicht aktiviert",
  "user-did-not-receive-activation-email": "Benutzer hat noch keine Aktivierungs-E-Mail erhalten",
  "allow-coworkers-to-show-on-profile": "Auf dem Benutzer-Profil der Mitarbeiter anzeigen:",
  "resend-activation-email": "Aktivierungslink anfordern",
  "coworker-education-status": "Mitarbeiter-Schulungsstatus",
  "card": "Visitenkarte",
  "certification-authority": "Zertifizierungsstelle",
  "certification-authority-admin": "Zertifizierungsstelle",
  "certification-authorities": "Zertifizierungsstellen",
  "delete-certification-authority": "Zertifizierungsstelle löschen",
  "certificate-templates": "Zertifikatsvorlagen",
  "certificate-template": "Zertifikatsvorlage",
  "creating-certificates": "Zertifikate werden erstellt...",
  "issue-certificate": "Zertifikat ausstellen",
  "issue-date": "Ausstellungsdatum",
  "due-date": "Ablaufdatum",
  "issued-on": "Ausgestellt am",
  "issued-by": "Ausgestellt von",
  "author": "Aussteller",
  "certificate-name": "Zertifikatsname",
  "certificate-number": "Zertifikatsnummer",
  "born-on": "geboren am",
  "mileage": "Kilometerstand",
  "public": "Öffentlich",
  "back-to-the-app": "Zurück zur App",
  "can-create-reports": "Prüfberichte möglich",
  "temporary-certification": "Temporäre Zertifizierung",
  "temporary-days-valid": "Gültig für (Tage)",
  "valid-for": "Gültig für (Jahre)",
  "pdf-template": "PDF-Vorlage",
  "pdf-certificate": "Eigenes PDF Zertifikat",
  "show-pdf-certificate": "Zertifikat als PDF",
  "standards": "Standards (HTML)",
  "text-block": "Text nach Standards (HTML)",
  "text-block-hint": "Platzhalter: {placeholders} — qualifikationen fügt die Texte der zugewiesenen GTP-Klassen ein",
  "digital-signature": "Digitale Unterschrift",
  "eval0": "HV-0",
  "eval1": "HV-1",
  "eval2": "HV-2",
  "eval3": "HV-3",
  "eval4": "HV-4",
  "evalc": "HV-C",
  "evalbex": "HV-BEX",
  "evall": "HV-L",
  "evalf": "HV-F",
  "evalpro": "HV-Pro",
  "evals": "HV-S",
  "evalt": "HV-T",
  "sonstige": "Sonstige",
  "others": "Andere",
  "levelGroupBase": "Basisstufen",
  "levelGroupSpecial": "Spezial - benötigt Vorbildung",
  "levelGroupSpecialTraining": "Spezialausbildungen ohne Voraussetzungen",
  "level": "Stufe",
  "type": "Typ",
  "training-data": "Schulungsunterlagen",
  "training-info": "Schulungsinformationen",
  "generated-password": "Generiertes Passwort",
  "invitation-email": "Einladungs-E-Mail",
  "document": "Dokument",
  "documents": "Dokumente",
  "active": "aktiv",
  "inactive": "inaktiv",
  "all": "ALLE",
  "all-sort": "Alle/Sortieren",
  "created-on": "Erstellt am",
  "result": "Ergebnis",
  "results": "Ergebnisse",
  "try-again": "Erneut versuchen",
  "status": "Status",
  "published": "Veröffentlicht",
  "draft": "Entwurf",
  "sn": "SN",
  "something-went-wrong": "Etwas ist schief gelaufen",
  "checking-prerequisites": "Voraussetzungen werden geprüft...",
  "prerequisite-warning-title": "Fehlende Voraussetzungen",
  "missing-prerequisites": "Benötigt mindestens:",
  "info-signs": "Hinweisschilder",
  "danger": "Achtung",
  "hazardous-voltage": "Gefährliche Spannung",
  "no-access-1": "Unbefugten",
  "no-access-2": "Zutritt verboten",
  "access-only-by": "Zutritt nur durch",
  "company-logo-is-missing": "Firmenlogo fehlt",
  "download": "Herunterladen",
  "access-denied": "Zutritt verboten",
  "dont-switch-on": "Nicht einschalten",
  "hv-system": "HV-System",
  "disconnected": "Freigeschaltet",
  "disconnected-by": "Freigeschaltet durch",
  "works-in-progress": "Es wird gearbeitet",
  "forum": "EV Forum",
  "topic": "Thema",
  "topics": "Themen",
  "title": "Titel",
  "created": "Erstellt",
  "created-by": "Erstellt von",
  "is-global": "Globale Vorlage",
  "templateauthor-requires-report-permission": "Nur Benutzer, die Berichte erstellen dürfen, können globale Vorlagenersteller werden.",
  "from": "von",
  "answers": "Antworten",
  "post-answer": "Antwort posten",
  "edit-answer": "Antwort bearbeiten",
  "new-topic": "Neues Thema",
  "edit-topic": "Thema bearbeiten",
  "create-new-topic": "Neues Thema erstellen",
  "last-answer": "Letzte Antwort",
  "view-all": "Alle ansehen",
  "attachments": "Anhänge",
  "link-url": "Link (URL)",
  "newest-topics": "Neueste Themen",
  "privacy-policy": "Datenschutz",
  "new-files": "Neue Dateien",
  "existing-files": "Vorhandene Dateien",
  "courses": "Kurse",
  "location": "Standort",
  "loading": "Laden",
  "view-details": "Details anzeigen",
  "no-courses-found": "Keine Kurse gefunden",
  "no-courses-assigned": "Keine Kurse verfügbar",
  "dialog": {
    "are-you-sure": "Sind Sie sicher?",
    "an-unexpected-error-occured": "Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es später noch einmal",
    "do-you-really-want-the-user-to": "Wollen Sie wirklich den Benutzer",
    "do-you-really-want-the-invitation-to": "Wollen Sie wirklich die Einladung",
    "delete": "löschen",
    "delete-user": "Benutzer löschen",
    "delete-topic": "Thema löschen",
    "delete-topic-answer": "Antwort löschen",
    "remove-user": "Benutzer entfernen",
    "remove-trainer": "Prüfer entfernen",
    "remove-from-company": "von der Firma entfernen?",
    "remove-from-certification-authority": "von der Zertifizierungsstelle entfernen?",
    "create-user": "Benutzer anlegen",
    "the-most-important-information": "Die wichtigsten Informationen",
    "create-company": "Firma anlegen",
    "the-most-important-information-about-the-company": "Die wichtigsten Informationen der Firma",
    "create-company-vehicle": "Firmenfahrzeug anlegen",
    "the-most-important-information-about-the-vehicle": "Die wichtigsten Informationen des Fahrzeugs",
    "the-most-important-information-about-the-asset": "Die wichtigsten Informationen des Objekts",
    "create-report": "Prüfbericht anlegen",
    "where-is-the-company-located": "Wo befindet sich die Firma?",
    "where-is-the-certification-authority-located": "Wo befindet sich die Zertifizierungsstelle?",
    "whats-the-role-of-the-person": "Was hat die Person für eine Funktion?",
    "where-does-the-person-live": "Wo wohnt die Person?",
    "further-details": "Weitere Details",
    "register-successfull": "Die Registrierung war erfolgreich! Sie erhalten in Kürze eine E-Mail mit Ihrem Passwort.",
    "great-you-will-receive-an-email": "Sie werden in Kürze eine E-Mail erhalten, mit der Sie Ihr Passwort zurücksetzen können",
    "this-should-not-take-longer-than": "Das sollte nicht länger als 5 Minuten dauern. Falls doch, sehen Sie bitte auch in Ihrem Spam-Ordner nach.",
    "i-agree": "Ich stimme den",
    "to": "zu",
    "terms-and-conditions": "Allgemeinen Geschäftsbedingungen",
    "hereby-i-agree": "Hiermit stimme ich zu, dass die EvalCert GmbH meine persönlichen Daten zum Zweck der Ausstellung einer EVAL-Karte und zur Benutzerregistrierung auf my.evalcard.com verwenden darf.",
    "further-i-agree-to": "Weiters stimme ich zu, dass die EvalCert GmbH mich via E-Mail-Newsletter, über Neuigkeiten im Hochvoltbereich (neue Trainings, Produktneuheiten oder Veranstaltungen), bis auf Widerruf informieren darf.",
    "allowed-to-be-used": " (.de bzw. .com) verwendet werden darf.",
    "refusal-is-allways": "Ein Widerruf ist jederzeit per Mail an",
    "possible": "möglich.",
    "the-e-val-card-is-the": "Die EVAL-Karte ist der Qualifikationsnachweis im Scheckkartenformat. Die Abkürzung EVAL steht für Electric Vehicle Access License",
    "complete-user-data": "Benutzerdaten vervollständigen",
    "complete-user-data-info": "Um Sie bestmöglich unterstützen zu können und Ihnen alle Funktionen zur Verfügung stellen zu können, benötigen wir von Ihnen ein vollständig ausgefülltes Benutzerprofil",
    "your-password-reset-is-being-processed": "Ihr Passwort wird in diesem Moment zurückgesetzt. Falls das länger als ein paar Minuten dauert, versuchen Sie es erneut.",
    "your-password-has-been-sent": "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie sollten innerhalb weniger Minuten eine E-Mail mit Ihrem neuen Passwort erhalten.",
    "if-it-did-not-work": "Sehen Sie auch in Ihrem Spam-Ordner nach. Sollten Sie nicht innerhalb von 5-10 Minuten Ihr neues Passwort erhalten haben, versuchen Sie es erneut.",
    "user-not-authorized": "E-Mail und/oder Passwort falsch",
    "user-not-activated": "Dieser Benutzer ist noch nicht aktiviert. Verwenden Sie den Link in der Aktivierungs-E-Mail",
    "user-or-password-wrong": "E-Mail oder Passwort ist falsch",
    "users-selected": "Benutzer ausgewählt",
    "user-profile-update-successfull": "Benutzerprofil wurde erfolgreich gespeichert",
    "user-profile-update-failed": "Benutzerprofil konnte nicht gespeichert werden. Bitte versuchen Sie es später noch einmal.",
    "do-you-really-want-to-leave-the-company": "Wollen Sie wirklich die Firma verlassen?",
    "in-order-to-accept-a-company-invitation": "Um eine Firmeneinladung annehmen zu können, müssen Sie bereits registriert und eingeloggt sein",
    "do-you-really-want-to-join-the-company": "Sind Sie sicher, dass Sie der Firma beitreten wollen?",
    "if-you-are-already-in-a-company-you-will-be-removed": "Sollten Sie bereits in einer Firma sein, werden Sie aus dieser entfernt",
    "you-are-not-a-member-of-a-company": "Sie sind zurzeit noch keiner Firma zugeteilt. Sobald Sie Mitglied einer Firma sind, können Sie diese Seite verwenden.",
    "you-are-not-a-member-of-a-certification-authority": "Sie sind zurzeit noch keiner Zertifizierungsstelle zugeteilt",
    "do-you-really-want-the-company-to": "Wollen Sie wirklich die Firma",
    "company-created-successfully": "Firma wurde erfolgreich erstellt",
    "company-already-exists": "Eine Firma mit diesem Namen bzw. dieser E-Mail existiert bereits. Deswegen konnte die Firma nicht erstellt werden",
    "vehicle-save-successfully": "Fahrzeug wurde erfolgreich gespeichert",
    "asset-save-successfully": "Objekt wurde erfolgreich gespeichert",
    "gtp-class-save-successfully": "GTP-Klasse wurde erfolgreich gespeichert",
    "gtp-class-already-exists": "Eine GTP-Klasse mit diesem Code existiert bereits",
    "do-you-really-want-the-gtp-class-to": "Wollen Sie wirklich die GTP-Klasse",
    "asset-type-save-successfully": "Objekttyp wurde erfolgreich gespeichert",
    "do-you-really-want-the-asset-type-to": "Wollen Sie wirklich den Objekttyp",
    "vehicle-already-exists": "Fahrzeug mit dieser VIN und Besitzer existiert bereits",
    "vehicle-accepted": "Fahrzeug wurde ins System übernommen",
    "vehicle-manufacturer-accepted": "Fahrzeughersteller wurde ins System übernommen",
    "report-save-successfully": "Prüfbericht wurde erfolgreich gespeichert",
    "report-already-exists": "Ein Prüfbericht mit diesem Namen oder Typ existiert bereits in dieser Firma.",
    "create-company-failed": "Firma konnte nicht erstellt werden. Bitte versuchen Sie es später noch einmal.",
    "save-user-success": "Benutzer wurde erfolgreich gespeichert",
    "user-already-exists": "Ein Benutzer mit dieser E-Mail oder diesem Namen existiert bereits.",
    "save-company-success": "Firma wurde erfolgreich gespeichert",
    "save-company-failed": "Firma konnte nicht gespeichert werden. Bitte versuchen Sie es später noch einmal.",
    "save-changes-success": "Änderungen wurden erfolgreich gespeichert",
    "do-you-really-want-the-vehicle-to": "Wollen Sie wirklich das Fahrzeug",
    "do-you-really-want-the-asset-to": "Wollen Sie wirklich das Objekt",
    "do-you-really-want-the-report-to": "Wollen Sie wirklich den Testbericht",
    "do-you-really-want-the-certificate-to": "Wollen Sie wirklich das Zertifikat",
    "do-you-really-want-the-vehicle-manufacturer-to": "Wollen Sie wirklich den Fahrzeughersteller",
    "save-vehicle-manufacturer-success": "Fahrzeughersteller wurde erfolgreich gespeichert",
    "save-vehicle-manufacturer-error": "Fahrzeughersteller konnte nicht gespeichert werden",
    "save-vehicle-success": "Fahrzeug wurde erfolgreich gespeichert",
    "save-vehicle-error": "Fahrzeug konnte nicht gespeichert werden",
    "who-works-in-the-company": "Wer arbeitet bei der Firma?",
    "who-works-in-the-certification-authority": "Wer arbeitet bei der Zertifizierungsstelle?",
    "your-company-has-been-created-check-your-emails": "Ihre Firma wurde erstellt! Sie sollten in Kürze eine E-Mail erhalten, mit der Sie Ihre Firma aktivieren können! Sehen Sie ggf. auch in Ihrem Spam-Ordner nach.",
    "if-you-havent-received-an-email-yet": "Wenn Sie innerhalb von 5 Minuten noch keine E-Mail erhalten haben, können Sie diese hier noch einmal anfordern.",
    "if-this-did-not-work": "Falls das noch immer nicht funktioniert hat, können Sie auch Ihre Firma verlassen und eine Neue anlegen.",
    "is-already-in-a-company": "ist bereits in einer Firma",
    "invite-user-already-exists-in-company": "Benutzer mit dieser E-Mail ist bereits in der Firma",
    "invite-user-already-exists-in-other-company": "Benutzer mit dieser E-Mail ist bereits in einer anderen Firma",
    "create-certification-authority": "Zertifizierungsstelle erstellen",
    "certification-authority-save-successfully": "Zertifizierungsstelle wurde erfolgreich gespeichert",
    "certification-authority-already-exists": "Eine Zertifizierungsstelle mit dieser E-Mail oder diesem Namen existiert bereits.",
    "certificate-already-exists": "Eine Zertifizierung mit diesem Namen existiert bereits für diesen Benutzer.",
    "certificate-save-successfully": "Zertifizierung wurde erfolgreich gespeichert",
    "do-you-really-want-to-delete": "Möchten Sie wirklich löschen",
    "delete-report-template": "Vorlage löschen",
    "create-certificate": "Zertifikat erstellen",
    "create-certificate-template": "Zertifikatsvorlage erstellen",
    "who-gets-the-certificate": "An wen soll das Zertifikat ausgestellt werden",
    "user-with-this-eval-id-was-not-found": "Benutzer mit dieser Eval-ID wurde nicht gefunden",
    "you-can-only-add-reports-if-you-have-company-vehicles": "Sie können einen Bericht nur erstellen, wenn Sie Firmenfahrzeuge besitzen",
    "you-can-only-input-eu-numbers": "Nur Zahlen im EU-Format möglich",
    "you-dont-have-the-rights": "Keine Berechtigung für diesen Bereich",
    "certificate-template-save-success": "Zertifikatsvorlage wurde erfolgreich gespeichert",
    "certificate-template-sort-save-success": "Sortierung der Zertifikatsvorlagen wurde erfolgreich gespeichert",
    "your-certification-authority-does-not-have-templates": "Bitte zuerst eine Zertifikatsvorlage erstellen, um Zertifikate ausstellen zu können",
    "this-company-is-not-yet-activated": "Diese Firma wurde noch nicht aktiviert. Der Aktivierungslink wurde an die E-Mail-Adresse der Firma geschickt",
    "welcome-to-the-dashboard": "Willkommen auf der Startseite! Sie sind zurzeit noch keiner Firma zugeteilt. Sobald Sie Mitglied einer Firma sind, können Sie hier eine Übersicht Ihrer Protokolle sehen",
    "valid-certificates": "Gültige Zertifikate",
    "certificates-last-30-days": "Zertifikate - letzten 30 Tage",
    "certificates-on": "Zertifikate am",
    "reports-last-30-days": "Berichte - letzten 30 Tage",
    "no-data-available": "Noch keine Daten vorhanden",
    "this-manufacturer-does-not-exist": "Dieser Hersteller ist noch nicht im System. Er wird für Sie automatisch angelegt.",
    "this-vehicle-does-not-exist": "Dieses Fahrzeug ist noch nicht im System. Es wird für Sie automatisch angelegt.",
    "required-to-complete-registration": "Um die Registrierung abschließen zu können, ist eine Zustimmung erforderlich",
    "email-is-already-used": "Diese E-Mail ist bereits vergeben",
    "enter-valid-birthday-date": "Bitte geben Sie ein gültiges Geburtsdatum ein",
    "enter-valid-eu-number-format": "Bitte verwenden Sie nur Zahlen im EU-Format",
    "only-use-numbers-with-or": "Bitte verwenden Sie nur Zahlen und '-' oder '/'",
    "this-user-is-already-in-this-certification-authority": "Dieser Benutzer ist bereits in dieser Zertifizierungsstelle",
    "this-user-is-already-selected": "Dieser Benutzer ist bereits ausgewählt",
    "this-user-is-already-in-a-company": "Dieser Benutzer ist bereits in einer Firma",
    "the-document-could-not-be-loaded": "Das Dokument konnte nicht geladen werden",
    "": "",
    "continue": "Weiter",
    "finish": "Fertig",
    "cannot-add-users": "Folgende Benutzer hatten Konflikte:",
    "add-course": "Kurs hinzufügen",
    "course-created-successfully": "Kurs erfolgreich erstellt.",
    "course-updated-successfully": "Kurs erfolgreich aktualisiert.",
    "mark-course-as-free": "Kurs als kostenlos markieren",
    "scan-qr-code": "QR-Code scannen",
    "scan-to-join-course": "QR-Code scannen, um Kurs beizutreten",
    "remove-participant": "Teilnehmer entfernen",
    "remove-participant-description": "Diesen Teilnehmer vom Kurs entfernen?",
    "user-is-already-participant": "Dieser Benutzer ist bereits Kursteilnehmer",
    "user-already-selected": "Benutzer wurde bereits gewählt",
    "delete-course": "Kurs löschen",
    "delete-course-description": "Dieser Kurs wird gelöscht. Alle Teilnehmer werden entfernt. Fortfahren?",
    "course-removed": "Kurs wurde entfernt",
    "remove-efk-success": "EFK-Status erfolgreich entfernt",
    "create-checklist": "Checkliste erstellen",
    "make-efk-success": "EFK-Status erfolgreich vergeben, der Benutzer wurde benachrichtigt",
    "resend-efk-success": "EFK-Einladung wurde erneut versendet",
    "participants-added-successfully": "Teilnehmer erfolgreich hinzugefügt",
    "delete-document": "Dokument löschen",
    "delete-document-description": "Möchten Sie dieses Dokument wirklich löschen?",
    "delete-certificate-template": "Zertifikatsvorlage löschen",
    "do-you-really-want-the-certificate-template-to": "Wollen Sie wirklich die Zertifikatsvorlage",
    'do-you-really-want-the-certification-authority-to': "Wollen Sie wirklich die Zertifizierungsstelle",
    "delete-task": "Aufgabe löschen",
    "do-you-really-want-to-delete-the-task": "Möchten Sie die Aufgabe \"{name}\" wirklich löschen?",
    "delete-section": "Abschnitt löschen",
    "do-you-really-want-to-delete-the-section": "Möchten Sie den Abschnitt \"{name}\" wirklich löschen?",
    "course-content-saved-successfully": "Kursinhalte erfolgreich gespeichert",
    "remove-certification-authority": "Zertifizierungsstelle entfernen",
    "do-you-really-want-to-remove-certification-authority": "Möchten Sie die Zertifizierungsstelle \"{name}\" wirklich entfernen?",
    "remove-course-content": "Kursinhalt entfernen",
    "do-you-really-want-to-remove-course-content": "Möchten Sie den Kursinhalt \"{name}\" wirklich entfernen?",
    "successfully-removed-course-content": "Kursinhalt erfolgreich entfernt",
    "language-already-exists-in-course": "Die ausgewählte Sprache existiert bereits in diesem Kurs",
    "do-you-really-want-to-remove-course": "Möchten Sie den Kurs \"{name}\" wirklich entfernen?",
    "successfully-removed-course": "Kurs erfolgreich entfernt",
    "publish-course-warning": "Sind Sie sicher, dass Sie '{name}' veröffentlichen möchten? Nach der Veröffentlichung kann der Kurs nicht mehr bearbeitet werden, bis er wieder zurückgenommen wird.",
    "unpublish-course-confirmation": "Sind Sie sicher, dass Sie '{name}' zurücknehmen möchten? Dies ermöglicht wieder Änderungen.",
    "course-published-successfully": "Kurs erfolgreich veröffentlicht",
    "course-unpublished-successfully": "Kurs erfolgreich zurückgenommen",
    "successfully-enrolled-course": "Erfolgreich in Kurs eingeschrieben",
    "remove-enrollment": "Einschreibung entfernen",
    "do-you-really-want-to-remove-enrollment": "Möchten Sie diese Einschreibung wirklich entfernen?",
    "successfully-removed-enrollment": "Einschreibung erfolgreich entfernt",
   },
  "tooltip": {
    "csv-export": "CSV-Export",
    "add-user": "Benutzer hinzufügen",
    "invite-user": "Benutzer einladen",
    "delete-user": "Benutzer löschen",
    "remove-user": "Benutzer entfernen",
    "edit-user": "Benutzer bearbeiten",
    "view-user": "Benutzer ansehen",
    "send-invitation-again": "Einladung erneut senden",
    "send-activation-again": "Aktivierungslink erneut senden",
    "admin-cant-leave-company": "Als EVAL-Beauftragter können Sie die Firma nicht verlassen",
    "leave-company": "Firma verlassen",
    "add-company": "Firma hinzufügen",
    "edit-company": "Firma bearbeiten",
    "delete-company": "Firma löschen",
    "add-selected-users-to-company": "Ausgewählte Benutzer einer Firma hinzufügen",
    "add-selected-users-to-course": "Ausgewählte Benutzer einem Kurs hinzufügen",
    "add-vehicle": "Fahrzeug hinzufügen",
    "show-vehicle": "Fahrzeugdetails",
    "edit-vehicle": "Fahrzeug bearbeiten",
    "view-vehicle": "Fahrzeug ansehen",
    "accept-vehicle": "Fahrzeug ins System übernehmen",
    "accept-vehicle-manufacturer": "Fahrzeughersteller ins System übernehmen",
    "delete-vehicle": "Fahrzeug löschen",
    "add-asset": "Objekt hinzufügen",
    "add-gtp-class": "GTP-Klasse hinzufügen",
    "edit-gtp-class": "GTP-Klasse bearbeiten",
    "delete-gtp-class": "GTP-Klasse löschen",
    "add-asset-type": "Objekttyp hinzufügen",
    "edit-asset-type": "Objekttyp bearbeiten",
    "delete-asset-type": "Objekttyp löschen",
    "show-asset": "Objektdetails",
    "edit-asset": "Objekt bearbeiten",
    "delete-asset": "Objekt löschen",
    "add-vehicle-manufacturer": "Fahrzeughersteller hinzufügen",
    "edit-vehicle-manufacturer": "Fahrzeughersteller bearbeiten",
    "delete-vehicle-manufacturer": "Fahrzeughersteller löschen",
    "vehicle-details-missing": "Fahrzeugdetails fehlen",
    "remove-invitation": "Einladung löschen",
    "send-missing-activations": "Fehlende Aktivierungs-E-Mails senden",
    "show-password": "Passwort anzeigen",
    "hide-password": "Passwort verbergen",
    "create-report": "Prüfbericht erstellen",
    "select-for-report": "Für Prüfbericht auswählen",
    "add-question": "Feld hinzufügen",
    "remove-question": "Feld entfernen",
    "create-certificates": "Zertifikate erstellen",
    "view-certificate": "Zertifikat ansehen",
    "delete-certificate": "Zertifikat löschen",
    "view-report": "Prüfbericht ansehen",
    "delete-report": "Prüfbericht löschen",
    "no-pdf-found": "Es wurde kein PDF-Dokument gefunden",
    "add-report": "Prüfbericht hinzufügen",
    "add-certificate": "Zertifikat erstellen",
    "no-certificate-to-create-report": "Sie haben kein passendes Zertifikat",
    "add-certification-authority": "Zertifizierungsstelle erstellen",
    "edit-certification-authority": "Zertifizierungsstelle bearbeiten",
    "delete-certification-authority": "Zertifizierungsstelle löschen",
    "add-certificate-template": "Zertifikatsvorlage erstellen",
    "edit-certificate-template": "Zertifikatsvorlage bearbeiten",
    "delete-certificate-template": "Zertifikatsvorlage löschen",
    "add-report-template": "Berichtsvorlage hinzufügen",
    "edit-report-template": "Berichtsvorlage bearbeiten",
    "delete-report-template": "Berichtsvorlage löschen",
    "view-certificate-training-data": "Schulungsunterlagen ansehen",
    "save-sorting": "Sortierung speichern",
    "mark-user": "Benutzer markieren",
    "open-topic": "Thema ansehen",
    "edit-topic": "Thema bearbeiten",
    "delete-topic": "Thema löschen",
    "edit-topic-answer": "Antwort bearbeiten",
    "delete-topic-answer": "Antwort löschen",
    "select-all-users": "Alle Benutzer markieren",
    "add-course": "Kurs hinzufügen",
    "show-qr": "QR-Code anzeigen",
    "edit-course": "Kurs bearbeiten",
    "publish-course": "Kurs veröffentlichen",
    "unpublish-course": "Kurs zurücknehmen",
    "remove-course": "Kurs löschen",
    "view-course": "Kurs ansehen",
    'remove-efk': 'EFK-Status entfernen',
    'see-more': 'Mehr anzeigen',
  },
  phone: 'Telefonnummer',
  address: 'Adresse',
  birthday: 'Geburtsdatum',
  'profile-picture': 'Profilbild',
  userprofile: {
    'edit-profile': 'Profil bearbeiten',
    'public-profile': 'Öffentliches Profil',
    'following-information': 'Folgende Informationen werden in Ihrem öffentlichen Profil angezeigt',
    'notification-settings':
      'Sollte Ihre Firma keine Benachrichtigungen senden, hat diese Einstellung keine Auswirkungen',
  },
  "training-director": "Schulungsleiter",
  "participated-the-training": "hat an der Ausbildung ",
  "result-protocol": "Ergebnisprotokoll",
  "measurements": "Messwerte",
  "freischaltung": "Freischaltung",
  "isolationswiderstand": "Isolationswiderstand",
  "potentialausgleich": "Potentialausgleich",
  "r": {
    "measuring-instrument-functionality": "Messgerätefunktion",
    "positive-test-done": "Positivtest durchgeführt",
    "voltage-between-hv-plus-and-chassis": "Spannung zwischen HV-Plus und Chassis",
    "voltage-between-hv-plus-and-hv-minus": "Spannung zwischen HV-Plus und HV-Minus",
    "voltage-between-hv-minus-and-chassis": "Spannung zwischen HV-Minus und Chassis",
    "the-tester-accepts-the-security-instructions": "Der Prüfer bestätigt die Einhaltung der Sicherheitshinweise des Herstellers",
    "measuring-instrument-tested-at-reference-source": "Messgerätefunktion an einer Referenzquelle überprüft?",
    "measuring-instrument-tested": "Messgerätefunktion überprüft?",
    "absence-of-voltage": "Spannungsfreiheit",
    "absence-of-voltage-confirmed": "Spannungsfreiheit festgestellt",
    "voltage": "Spannung (V)",
    "used-voltage": "Verwendete Spannung",
    "used-test-voltage": "Angewendete Prüfspannung",
    "isolation-standard": "Sollwert des Isolationswiderstandes",
    "resistance-per-volt": "Widerstand pro Volt",
    "hv-system-voltage": "HV-Betriebsspannung / HV-Systemspannung",
    "isolation-resistance-between-hv-plus-and-chassis": "Isolationswiderstand zwischen HV-Plus und Chassis",
    "isolation-resistance-between-hv-minus-and-chassis": "Isolationswiderstand zwischen HV-Minus und Chassis",
    "further-measurements-if-needed": "Weitere Messung falls gewünscht",
    "test-current": "Prüfstrom (A)",
    "test-current-q": "Prüfstrom ...",
    "measuring-point": "Messpunkt",
    "measuring-point-chassis-vs": "Messpunkt Chassis gegen ...",
    "converter-housing": "Invertergehäuse",
    "further-voltage-measurements-if-needed": "Weitere Spannungsmessung falls gewünscht",
    "measurements-ok-if-smaller-than-1-v": "Messergebnis positiv, wenn gemessene Spannung kleiner als 1V",
    "visual-inspection": "Sichtprüfung",
    "cable-visual-inspection": "Kabel auf sichtbare Beschädigungen geprüft?",
    "connector-visual-inspection": "Stecker auf sichtbare Beschädigungen geprüft?",
    "isolation-test": "Isolationsprüfung",
    "cable-isolation-test": "Isolationswiderstand des Kabels geprüft?",
    "function-test": "Funktionstest",
    "cable-function-test": "Ladevorgang erfolgreich getestet?",
    "charging-cable-inspection-notes": "Weitere Prüfungen falls erforderlich"
  },
  'new-report-no-id': 'Neuer Prüfbericht',
  'required-field': 'Dieses Feld ist ein Pflichtfeld.',
  'fill-out-all-required-fields': 'Bitte füllen Sie alle Pflichtfelder aus!',
  'valid-email-only': 'Bitte geben Sie eine gültige E-Mail ein.',
  'max-characters': 'Max {count} Zeichen',
  'certificate-notification': 'Zertifikatsbenachrichtigungen',
  'certificate-notification-company': 'Damit können Benachrichtigungen für alle Mitarbeiter deaktiviert werden.',
  'calibration-notification': 'Kalibrierungsbenachrichtigungen',
  'calibration-notification-company': 'Erinnerung, bevor die Kalibrierung eines Objekts abläuft.',
  'haynes-pro-vehicle-details': 'HaynesPro Fahrzeugdetails',
  'haynes-pro-no-details': 'Es sind keine Fahrzeugdetails für das gewählte Fahrzeug verfügbar.',
  'haynes-pro-hv-disconnect': 'Hochvoltsystem: spannungsfrei schalten',
  'vehicle-details-admin': 'Fahrzeugdetails',
  'haynes-pro-details': 'HaynesPro-Details',
  'haynes-pro-details-admin': 'HaynesPro-Details',
  'haynes-pro-details-not-found': 'Leider wurde für dieses Fahrzeug nichts gefunden.',
  'haynes-pro-load-error': 'Die Anleitung konnte nicht geladen werden.',
  retry: 'Erneut versuchen',
  'haynes-pro-details-more-than-one-story': 'Es wurde mehr als eine Anleitung gefunden:',
  participants: 'Teilnehmer',
  'join-course': 'Kurs beitreten',
  'join-course-description':
    'Kurs wirklich beitreten? Der Trainer des Kurses kann Sie dann als Kursteilnehmer verwalten.',
  'course-id-required': 'Kurs-ID ist verpflichtend, um einem Kurs beizutreten!',
  'course-not-found': 'Kurs wurde nicht gefunden',
  'error-loading-course': 'Fehler beim Laden des Kurses',
  'successfully-joined-course': 'Kurs erfolgreich beigetreten',
  'error-joining-course': 'Fehler beim Beitreten, kontaktieren Sie Ihren Trainer.',
  refresh: 'Neuladen',
  'edit-course': 'Kurs bearbeiten',
  'make-efk': 'Als EFK bestellen',
  'make-efk-description': 'Diesen Benutzer als EFK bestellen? Er muss es bestätigen.',
  'resend-efk-invitation': 'EFK-Einladung erneut senden',
  'cancel-efk': 'EFK-Bestellung stornieren',
  efk: 'EFK',
  'efk-position': 'EFK (Elektrofachkraft) Position',
  'do-you-want-to-accept-efk-position': 'Möchten Sie die Position als EFK (Elektrofachkraft) annehmen?',
  'do-you-want-to-refuse-efk-position': 'Möchten Sie die Position als EFK (Elektrofachkraft) ablehnen?',
  refuse: 'Ablehnen',
  'in-order-to-handle-efk-position':
    'Um die Position als EFK (Elektrofachkraft) annehmen zu können, müssen Sie bereits registriert und eingeloggt sein',
  'efk-position-accepted': 'Die Position als EFK (Elektrofachkraft) wurde angenommen',
  'efk-position-refused': 'Die Position als EFK (Elektrofachkraft) wurde abgelehnt',
  pending: 'Ausstehend',
  'remove-efk-description': 'Möchten Sie diesem Benutzer die EFK-Position entziehen?',
  'cancel-efk-description': 'Möchten Sie die EFK-Einladung für diesen Benutzer wirklich stornieren?',
  aborted: 'Abgelehnt',
  checklists: 'Checklisten',
  'all-checklists': 'Alle Checklisten',
  manage: 'Verwalten',
  'global-templates': 'Globale Vorlagen',
  'global-template-authors': 'Globale Vorlagenersteller',
  'add-global-template-author': 'Globalen Ersteller hinzufügen',
  'remove-global-template-author-confirm': 'Wirklich als globalen Vorlagenersteller entfernen?',
  'report-templates': 'Berichtsvorlagen',
  'report-template': 'Berichtsvorlage',
  'create-report-template': 'Berichtsvorlage erstellen',
  'edit-report-template': 'Berichtsvorlage bearbeiten',
  'delete-report-template': 'Berichtsvorlage löschen',
  checklist: 'Checkliste',
  form: 'Fahrzeugprüfbericht',
  'basic-information': 'Grundinformationen',
  'object-data': 'Objektdaten',
  'object-data-configuration': 'Objektdaten-Konfiguration',
  'object-data-config-description': 'Konfigurieren Sie benutzerdefinierte Felder zur Datenerfassung',
  'requires-vehicle': 'Fahrzeug gebunden',
  'assigned-vehicles': 'Zugeordnete Fahrzeuge',
  'assigned-vehicles-hint': 'Leer = gilt für alle Fahrzeuge',
  'assigned-vehicles-no-data': 'Fahrzeug suchen …',
  'available-reports': 'Verfügbare Berichte',
  'create-report-now': 'Bericht erstellen',
  'vehicle-added-to-fleet': 'Fahrzeug steht jetzt in Ihren Firmenfahrzeugen',
  'requires-asset': 'Objekt gebunden',
  'select-asset': 'Objekt auswählen',
  'field-name': 'Feldname',
  'display-name': 'Anzeigename',
  'add-field': 'Feld hinzufügen',
  'questions-description': 'Konfigurieren Sie die Fragen für diese Vorlage',
  'add-question': 'Frage hinzufügen',
  'example-images': 'Beispielbilder',
  'upload-example-images': 'Beispielbilder hochladen',
  'remove-image': 'Bild entfernen',
  'images-uploaded-successfully': 'Bilder erfolgreich hochgeladen',
  'error-uploading-images': 'Fehler beim Hochladen der Bilder',
  'enable-validation': 'Validierung aktivieren',
  'validation-configuration': 'Validierungs-Konfiguration',
  'expected-value': 'Erwarteter Wert',
  'at-least-one-language-required': 'Mindestens eine Sprache ist erforderlich',
  'language-not-available': 'Diese Sprache existiert nicht',
  'multilingual-fields-info':
    'Mehrsprachige Felder: Geben Sie nur die Sprachen ein, für die Sie Übersetzungen haben. Mindestens eine Sprache ist für Namen und Fragen erforderlich.',
  operator: 'Operator',
  'validation-value': 'Validierungswert',
  equal: 'Gleich',
  'less-than': 'Kleiner als',
  'greater-than': 'Größer als',
  'form-vehicle-info':
    'Dies ist eine Formular-Vorlage. Formulare werden verwendet, wenn ein Fahrzeug für den Bericht erforderlich ist.',
  'checklist-object-data-info':
    'Dies ist eine Checklisten-Vorlage. Checklisten verwenden Objektdaten-Konfiguration anstelle von Fahrzeugen.',
  'protocols-title': 'Berichte',
  'evalus-reports': 'Allgemeine Vorlagen',
  'company-reports': 'Firmenberichte',
  'custom-templates': 'Benutzerdefinierte Vorlagen',
  description: 'Beschreibung',
  questions: 'Überprüfungsfragen',
  question: 'Frage',
  unit: 'Einheit',
  boolean: 'Ja/Nein',
  text: 'Text',
  // Eigener Key: der generische `number` ist "Nummer" (Ordnungszahl) und passt hier nicht.
  'question-type-number': 'Zahl',
  dropdown: 'Auswahl',
  options: 'Optionen',
  option: 'Option',
  'add-option': 'Option hinzufügen',
  'expected-option': 'Erwartete Option',
  'dropdown-options-required': 'Jede Auswahl-Frage braucht mindestens eine ausgefüllte Option',
  'no-questions-yet': 'Noch keine Fragen — füge die erste hinzu',
  'no-fields-yet': 'Noch keine Felder — füge das erste hinzu',
  'question-incomplete': 'Diese Frage ist noch unvollständig',
  'is-active': 'Aktiv',
  'add-checklist': 'Checkliste hinzufügen',
  "select-checklist-template": "Wählen Sie eine Checklisten-Vorlage aus",
  "no-checklist-templates-available": "Es sind keine Checklisten-Vorlagen verfügbar.",
  "template": "Vorlage",
  "checklist-object-data": "Daten des Berichts",
  "report-template-saved": "Berichtsvorlage wurde erfolgreich gespeichert",
  "new-checklist": "Neue Checkliste",
  "view-checklist": "Checkliste anzeigen",
  "checklist-from": "Checkliste vom",
  "checklist-details": "Checklistendetails",
  "field": "Feld",
  "checklist-created-successfully": "Checkliste wurde erfolgreich erstellt",
  "error-creating-checklist": "Fehler beim Erstellen der Checkliste. Bitte versuchen Sie es später erneut.",
  "tested-with-object": "Mit dem Objekt",
  "required-asset-type": "Benötigter Objekttyp",
  "required-asset-type-hint": "Objekttyp, mit dem diese Fahrzeugprüfung durchgeführt werden muss. Leer lassen, wenn kein Objekt nötig ist.",
  "can-calibrate": "Kann Objekte kalibrieren",
  "calibratable-asset-type": "Kalibrierbarer Objekttyp",
  "calibratable-asset-type-hint": "Nur Objekte dieses Typs können mit dieser Checkliste kalibriert werden.",
  "calibration-validity-months": "Kalibrier-Gültigkeit (Monate)",
  "calibration-validity-months-hint": "Wird diese Checkliste fehlerfrei abgeschlossen, gilt das Objekt für so viele Monate wieder als kalibriert.",
  "select-required-asset": "Verwendetes Objekt",
  "asset-locked-calibration-expired": "Gesperrt – Kalibrierung seit über {days} Tagen abgelaufen ({date})",
  "asset-calibration-expired-on": "Kalibrierung abgelaufen am {date}",
  "asset-restricted-hint": "Diese Prüfung darf nur mit einem Objekt vom Typ „{type}“ durchgeführt werden.",
  "asset-none-of-required-type": "Ihre Firma hat kein Objekt vom Typ „{type}“. Legen Sie zuerst ein passendes Objekt an, um diese Prüfung durchführen zu können.",
  "asset-all-expired": "Bei allen passenden Objekten ist die Kalibrierung seit über {days} Tagen abgelaufen, sie sind deshalb gesperrt. Aktualisieren Sie das Kalibrierdatum am Objekt, um fortzufahren.",
  "asset-no-longer-allowed": "Das gewählte Objekt ist für diese Prüfung nicht (mehr) zulässig – möglicherweise ist die Kalibrierung zwischenzeitlich zu lange abgelaufen. Bitte Auswahl prüfen.",
  "add-users-to-course": "Benutzer zum Kurs hinzufügen",
  "selected-users": "Ausgewählte Benutzer",
  "start-date": "Startdatum",
  "end-date": "Enddatum",
  "evalus-reports-info": "Hier finden Sie 'Allgemeine Vorlagen'. Spezielle Berichte können Sie im Menüpunkt 'Checklisten' finden bzw. erstellen und verwalten.",
  'role': 'Rolle',
  "eup": "EUP",
  "efk-tooltip": "Elektrofachkraft",
  "eup-tooltip": "Elektrotechnisch unterwiesene Person",
  "efk-pending": "Bestellung ausstehend",
  "strictly-required": "Zwingend erforderlich",
  "strictly-required-info": "Wenn aktiviert, kann der Bericht nicht abgeschickt werden, sofern diese Validierung fehlschlägt",
  "validation-failed": "Pflichtvalidierung fehlgeschlagen",
  "cannot-submit-invalid-required": "Kann nicht abgeschickt werden: Erforderliche Validierung fehlgeschlagen",
  "create-new-entry": "Neuen Eintrag erstellen",
  "trainer-invalid-certificate": "Der Trainer hat kein gültiges HV-4 oder HV-L Zertifikat mehr.",
  "to": "bis",
  "date-filter": "Datumsfilter",
  "clear-filter": "Filter löschen",
  "oldest-first": "Älteste zuerst",
  "newest-first": "Neueste zuerst",
  "course-documents": "Kursbeilagen",
  "select-documents": "Dokumente auswählen",
  "upload-documents": "Dokumente hochladen",
  "uploading": "Hochladen",
  "drag-and-drop-files": "Dateien hierher ziehen und ablegen",
  "drop-files-here": "Dateien hier ablegen",
  "or-click-to-browse": "oder klicken Sie, um Dateien auszuwählen",
  "supported-formats": "Unterstützte Formate",
  "existing-documents": "Vorhandene Dokumente",
  "documents-uploaded-successfully": "Dokumente erfolgreich hochgeladen",
  "document-deleted-successfully": "Dokument erfolgreich gelöscht",
  "no-course-documents-available": "Sie sind derzeit keinem Kurs zugeordnet oder es wurden keine Dokumente bereitgestellt.",
  "more-files": "Weitere Dateien",
  "publicProfile": {
    "status": {
      "valid": "Gültig",
      "expiringSoon": "Läuft bald ab",
      "expired": "Abgelaufen",
      "certified": "Zertifiziert",
      "open": "Offen",
      "none": "Keine"
    },
    "jobTitle": {
      "efk": "HV-EFK",
      "hv0": "HV Sensibilisierte Person",
      "hv1-3": "HV-EUP",
    },
    "experienceStartDate": "Berufserfahrung seit",
    "backgroundImage": "Hintergrundbild",
    "totalCertificatesTitle": "Zertifikate",
    "totalCertificatesDescription": "Anzahl aller Zertifikate",
    "trainingLevelTitle": "Ausbildungsstufe",
    "trainingLevelDescription": "Höchste Ausbildungsstufe",
    "practicalOperationsTitle": "Praktische Einsätze",
    "practicalOperationsDescription": "Praktische Tätigkeiten an HV-Systemen",
    "vehicleModelsTitle": "Fahrzeugmodelle",
    "vehicleModelsDescription": "Betreute HV-Fahrzeugmodelle",
    "dashboardTitle": "HV-Erfahrungs-Dashboard",
    "dashboardSubtitle": "Umfassende Statistiken & HV-Expertise",
    "certificationsTitle": "Zertifizierungen",
    "certificationsSubtitle": "Übersicht über die Aus- und Weiterbildung im HV-Bereich",
    "instructor": "Ausbilder",
    "issuedOn": "Ausgestellt",
    "validUntil": "Gültig bis",
    "view": "Ansehen",
    "loadMoreCertificates": "Weitere Zertifikate laden",
    "hideCertificates": "Zertifikate ausblenden",
    "nav": {
      "certifications": "Zertifizierungen",
      "specialTraining": "Spezialausbildungen",
      "practicalExperiences": "Praktische Erfahrungen",
      "vehicleCategories": "Fahrzeugkategorien"
    },
    "specialTraining": {
      "title1": "Spezial",
      "title2": "Ausbildungen",
      "subtitle": "Zusätzliche Qualifikationen und Spezialausbildungen"
    },
    "practicalExperiences": {
      "title1": "Praktische",
      "title2": "Erfahrungen",
      "subtitle": "Praktische Erfahrung an HV-Systemen",
      "freischaltungen": {
        "title": "Freischaltungen",
        "description": "Durchgeführte Freischaltungen an HV-Systemen"
      },
      "isolationstests": {
        "title": "Isolationsmessungen",
        "description": "Durchgeführte Isolationswiderstandsmessungen"
      },
      "potentialtests": {
        "title": "Potentialausgleich",
        "description": "Durchgeführte Potentialausgleichsmessungen"
      },
      "checklists": {
        "title": "Checklisten durchgeführt",
        "description": "Abgeschlossene Sicherheits-Checklisten"
      },
      "chargingCableChecks": {
        "title": "Ladekabelprüfungen",
        "description": "HV-C zertifizierte Kabel-Sicherheitsinspektionen"
      },
      "issuedCertificates": {
        "title": "Ausgestellte Zertifikate",
        "description": "Als Trainer ausgestellte Zertifizierungen"
      }
    },
    "vehicleCategories": {
      "title1": "Fahrzeugkategorie ",
      "title2": "Erfahrungen",
      "subtitle": "Spezialisiert auf folgende Fahrzeugkategorien und Anwendungen"
    },
    "gtpCategories": {
      "roadVehicles": "Straßenfahrzeuge",
      "machines": "Baumaschinen",
      "racingVehicles": "Rennfahrzeuge",
      "aircraft": "Luftfahrzeuge",
      "watercraft": "Wasserfahrzeuge",
      "railVehicles": "Bahnfahrzeuge",
      "developmentProduction": "F&E",
      "aftersales": "Aftersales"
    },
    "footer": {
      "qrTitle": "QR-Code-Zugang",
      "qrSubtitle": "Code scannen für Schnellzugriff auf Profil",
      "qrHint": "Mit Kamera scannen",
      "copyright": "© {year} Evalcard.com - Alle Rechte vorbehalten",
      "imprint": "Impressum",
      "privacy": "Datenschutz",
    },
    "shareProfile": "Profil teilen",
    "currentEmployer": "Aktueller Arbeitgeber",
    "linkCopied": "Link erfolgreich in Zwischenablage kopiert",
    "evalusProfile": "Evalus Profil",
    "sharingNotSuccessful": "Teilen nicht erfolgreich.",
    "showInvalidCertificates": "Abgelaufene Zertifikate anzeigen",
    "hideInvalidCertificates": "Abgelaufene Zertifikate ausblenden",
    "invalidCertificatesHint": "Ausgeblendete Zertifikate, die durch neuere ersetzt wurden",
    "evalId": "Eval-ID Nr.",
    "ogCertifications": "Zertifizierungen",
    "ogDescription": "Öffentliches Profil auf EvalCard"
  },
  academy: {
    academy: 'Akademie',
    administration: 'Verwaltung',
    'my-orders': 'Meine Bestellungen',
    'manage-courses': 'Kurse verwalten',
    data: 'Stammdaten',
    price: 'Preis',
    'book-for-me': 'Für mich buchen',
    'book-for-employee': 'Für Mitarbeiter buchen',
    passing_score: 'Erforderliche Punktzahl in %',
    max_exam_attempts: 'Maximale Prüfungsversuche',
    max_exam_attempts_hint: '0 = Unbegrenzt',
    exam_attempts_remaining: 'Verbleibende Versuche: {remaining} von {max}',
    exam_attempts_used: 'Versuche: {used}',
    exam_attempts_limit_reached: 'Maximale Anzahl an Prüfungsversuchen erreicht',
    'edit-course': '@:edit-course',
    'all-languages-have-content': 'Für alle Sprachen existieren bereits Kursinhalte.',
    'must-be-company-member-to-book': 'Sie müssen Mitglied eines Unternehmens sein, um Kurse buchen zu können.',
  },
  course: {
    course: 'Kurs',
    courses: 'Kurse',
    'my-courses': 'Meine Kurse',
    'my-courses-view': 'Kursübersicht',
    content: 'Kursinhalt',
    'edit-content': 'Kursinhalt bearbeiten',
    learn: 'Lernen',
    'learn-trail': 'Lernpfad',
    exam: 'Prüfung',
    'exam-trail': 'Prüfungspfad',
    section: 'Bereich',
    addLearnSection: 'Lernbereich hinzufügen',
    addLearnTask: 'Lernaufgabe hinzufügen',
    addExamSection: 'Prüfungsbereich hinzufügen',
    addExamTask: 'Prüfungsfrage hinzufügen',
    sectionTitle: 'Bereichstitel',
    taskTitle: 'Aufgabentitel',
    questionTitle: 'Fragentitel',
    enterSectionTitle: 'Bereichstitel eingeben...',
    enterTaskTitle: 'Aufgabentitel eingeben...',
    enterQuestionTitle: 'Fragentitel eingeben...',
    titleRequired: 'Titel ist erforderlich',
    titleTooShort: 'Titel muss mindestens 2 Zeichen lang sein',
    itemAddedSuccessfully: 'Element erfolgreich hinzugefügt',
    errorAddingItem: 'Fehler beim Hinzufügen des Elements',
    selectItemFromSidebar: 'Wählen Sie ein Element aus der Seitenleiste',
    task: 'Aufgabe',
    question: 'Frage',
    enterTitle: 'Titel eingeben...',
    addItem: 'Element hinzufügen',
    'purchase-course': 'Kurs kaufen',
    'purchase-initiated': 'Kauf erfolgreich eingeleitet',
    'learning-objectives': 'Lernziele',
    prerequisites: 'Voraussetzungen',
    syllabus: 'Kurs-Lehrplan',
    'learn-section': 'Lernabschnitt',
    'exam-section': 'Prüfungsabschnitt',
    free: 'Kostenlos',
    booking: 'Buchung',
    'purchase-date': 'Gebucht am',
    question_type: {
      question_type: 'Fragetyp',
      multiple_choice: 'Multiple-Choice',
      number: 'Nummer',
      yes_no: 'Ja / Nein',
    },
    operator: {
      operator: 'Operator',
      equals: 'Gleich',
      notEquals: 'Nicht gleich',
      greaterThan: 'Größer als',
      lessThan: 'Kleiner als',
      greaterThanOrEqual: 'Größer oder gleich',
      lessThanOrEqual: 'Kleiner oder gleich',
    },
    correct_answer: 'Richtige Antwort',
    yes: 'Ja',
    no: 'Nein',
    answer: 'Antwort',
    unit: 'Einheit',
    select_course: 'Kurs auswählen',
    select_language: 'Kurssprache auswählen',
    select_users: 'Benutzer auswählen',
    error: {
      publish: 'Fehler beim Veröffentlichen des Kurses',
      course_content_required: 'Mindestens ein Kursinhalt ist erforderlich',
      certification_authority_required: 'Mindestens eine Zertifizierungsstelle ist erforderlich',
      certificate_template_missing: 'Für jeden Kursinhalt muss für alle Zertifizierungsstellen eine Zertifikatsvorlage ausgewählt sein',
      learn_section_task_required: 'Jeder Lernbereich muss mindestens eine Lernaufgabe enthalten',
      exam_section_task_required: 'Jeder Prüfungsbereich muss mindestens eine Prüfungsfrage enthalten',
      monetization_required: 'Der Kurs muss entweder als kostenlos markiert sein oder ein Paddle-Produkt zugeordnet haben',
    },
    finish_course: 'Kurs abschließen',
    completed_message: 'Sie haben diesen Kurs erfolgreich abgeschlossen.',
    linked_exam_section: 'Verknüpfter Prüfungsabschnitt',
    linked_exam_section_hint: 'Nach Abschluss dieses Lernabschnitts wird dieser Prüfungsabschnitt abgefragt',
    inline_exam_section: 'Prüfungsfragen',
    inline_exam_section_info: 'Bitte beantworten Sie alle Fragen, um fortzufahren. Ihre Antworten sind endgültig.',
    question_progress: 'Frage {current} von {total}',
    complete_exam_section: 'Abschnitt abschließen',
    answered_during_learning: 'Während des Lernens beantwortet',
    section_already_answered: 'Dieser Abschnitt wurde bereits beantwortet',
    answers_are_final: 'Die Antworten können nicht mehr geändert werden',
  },
  enrollment: {
    status: {
      in_progress: 'Begonnen',
      not_started: 'Nicht begonnen',
      completed: 'Abgeschlossen',
    },
    enrolled_courses: 'Eingeschriebene Kurse',
    enroll_course: 'Kurs einschreiben',
    enrolled_on: 'Eingeschrieben am',
  },
  order: {
    order: 'Bestellung | Bestellungen',
    my_orders: 'Meine Bestellungen',
    view_order: 'Ansehen',
    ordered_at: 'Bestellt am',
    status: {
      paid: 'Bezahlt',
      pending: 'Ausstehend',
      failed: 'Fehlgeschlagen',
      refunded: 'Rückerstattet',
      cancelled: 'Storniert',
    },
    payment: {
      paddle: 'Paddle',
      request: 'Anfrage',
      none: 'Keine',
    },
    payment_method: 'Zahlungsmethode',
    purchased_by: 'Gekauft von',
    purchased_for: 'Gekauft für',
    product: 'Produkt',
    'page-title': 'Bestellung',
    thank_you: 'Vielen Dank für Ihren Kauf!',
    no_transaction_headline: 'Bestellung nicht gefunden',
    no_transaction_text: 'Diese Bestellung existiert nicht oder ein Fehler ist aufgetreten.',
    back_to_courses: 'Zurück zu den Kursen',
    go_to_my_courses: 'Zu meinen Kursen',
    purchase_now: 'Jetzt kaufen',
    payment_pending: 'Zahlung ausstehend',
    payment_pending_text:
      'Ihre Bestellung wurde erhalten, aber die Zahlung wurde noch nicht abgeschlossen. Bitte schließen Sie die Zahlung ab, um auf Ihren Kurs zuzugreifen.',
    cancel_success: 'Bestellung erfolgreich storniert',
    cancel_error: 'Fehler beim Stornieren der Bestellung',
  },
  language: 'Sprache',
  short_description: 'Kurzbeschreibung',
  progress: 'Fortschritt',
  total: 'Gesamt',
  complete_section: 'Abschnitt abschließen',
  mark_task_complete: 'Aufgabe als erledigt markieren',
  video_not_supported: 'Ihr Browser unterstützt das Video-Element nicht.',
  overall_progress: 'Gesamtfortschritt',
  section_progress: 'Abschnittsfortschritt',
  task_completed: 'Aufgabe erfolgreich abgeschlossen',
  section_completed: 'Abschnitt erfolgreich abgeschlossen',
  error_completing_task: 'Fehler beim Abschließen der Aufgabe',
  error_completing_section: 'Fehler beim Abschließen des Abschnitts',
  next: 'Weiter',
  finish_learning: 'Lernen beenden',
  start_learning: 'Lernen starten',
  continue_learning: 'Lernen fortsetzen',
  take_exam_attempt: 'Prüfung starten',
  copy_course: 'Kurs kopieren',
  select: 'Auswählen',
  exam_results: {
    congratulations: 'Herzlichen Glückwunsch!',
    not_passed: 'Nicht bestanden',
    score: 'Punktzahl',
    you_passed: 'Sie haben die Prüfung erfolgreich bestanden!',
    need_score_to_pass: 'Sie benötigen {score}, um zu bestehen. Bitte versuchen Sie es erneut.',
    score_details: 'Punktzahldetails',
    question: 'Frage',
    back_to_course: 'Zurück zum Kurs',
    retake_exam: 'Prüfung wiederholen',
    view_certificate: 'Zertifikat anzeigen',
    download_certificate: 'Zertifikat herunterladen',
  },
  exam_export: {
    export_pdf: 'Als PDF exportieren',
    title: 'Prüfungsergebnis',
    participant: 'Teilnehmer',
    birthday: 'Geburtsdatum',
    course: 'Kurs',
    attempt_number: 'Versuch',
    started_at: 'Begonnen am',
    finished_at: 'Abgeschlossen am',
    overall_score: 'Gesamtergebnis',
    passed: 'Bestanden',
    failed: 'Nicht bestanden',
    given_answer: 'Gegebene Antwort',
    correct_answer: 'Richtige Antwort',
    no_answer: 'Keine Antwort',
    yes: 'Ja',
    no: 'Nein',
    select_attempt: 'Versuch auswählen',
    no_attempts: 'Keine abgeschlossenen Versuche vorhanden',
    no_exam: 'Dieser Kurs hat keine Prüfung',
    generating: 'PDF wird erstellt …',
    export_failed: 'Export fehlgeschlagen',
  },
  'academy-assignment': {
    title: 'Zugewiesene Akademiekurse',
    'academy-course': 'Akademiekurs',
    'available-for-regular-courses': 'Für reguläre Kurse auswählbar',
    'for-regular-courses-badge': 'Für reguläre Kurse',
    'cannot-publish-regular-course': 'Dieser Kurs kann nicht veröffentlicht werden, weil er für reguläre Kurse gedacht ist',
    language: 'Sprache',
    'select-course-first': 'Zuerst einen Akademiekurs auswählen',
    'no-matching-courses': 'Keine passenden Akademiekurse verfügbar (unveröffentlicht, freigegeben, passendes Level)',
    type: 'Typ',
    'type-entry': 'Eingangstest',
    'type-intermediate': 'Zwischentest',
    'type-final': 'Endprüfung',
    assign: 'Akademiekurs zuweisen',
    remove: 'Zuweisung entfernen',
    'remove-warning': 'Wird die Zuweisung entfernt, werden die Einschreibungen und Prüfungsergebnisse der Teilnehmer für diesen Akademiekurs gelöscht. Fortfahren?',
    'assigned-successfully': 'Akademiekurs erfolgreich zugewiesen',
    'removed-successfully': 'Zuweisung erfolgreich entfernt',
    results: 'Ergebnisse der Teilnehmer',
    participant: 'Teilnehmer',
    score: 'Ergebnis',
    status: 'Status',
    attempts: 'Versuch',
    passed: 'Bestanden',
    failed: 'Nicht bestanden',
    'in-progress': 'In Bearbeitung',
    'not-started': 'Nicht begonnen',
  },
  exam_interface: {
    sections: 'Abschnitte',
    overall_progress: 'Gesamtfortschritt',
    questions: 'Fragen',
    progress: 'Fortschritt',
    section: 'Abschnitt',
    question_of: 'Frage {current} von {total}',
    answered: 'Beantwortet',
    not_answered: 'Nicht beantwortet',
    previous: 'Zurück',
    next: 'Weiter',
    submit_exam: 'Prüfung abschließen',
    quick_navigation: 'Schnellnavigation',
    submit_exam_confirm: 'Prüfung abgeben?',
    submit_exam_message: 'Sind Sie sicher, dass Sie Ihre Prüfung abgeben möchten?',
    answered_count: 'Sie haben <strong>{answered}</strong> von <strong>{total}</strong> Fragen beantwortet.',
    cannot_change_warning: 'Nach der Abgabe können Sie Ihre Antworten nicht mehr ändern.',
    loading: 'Laden',
    error: 'Fehler',
    back: 'Zurück',
    select_certificate_authority: 'Zertifizierungsstelle auswählen',
    select_authority_message: 'Bitte wählen Sie eine Zertifizierungsstelle aus, um Ihr Zertifikat auszustellen.',
    no_authorities_available: 'Für diesen Kurs sind keine Zertifizierungsstellen verfügbar.',
    certificate_issued: 'Zertifikat erfolgreich ausgestellt!',
    error_issuing_certificate: 'Fehler beim Ausstellen des Zertifikats',
    exam_submitted_successfully: 'Prüfung erfolgreich abgegeben!',
    exam_submit_error: 'Fehler beim Abgeben der Prüfung',
  },
  could_not_add_section: 'Abschnitt konnte nicht hinzugefügt werden',
  successfully_added_section: 'Abschnitt erfolgreich hinzugefügt',
  could_not_add_task: 'Aufgabe konnte nicht hinzugefügt werden',
  successfully_added_task: 'Aufgabe erfolgreich hinzugefügt',
  could_not_remove_attachment: 'Anhang konnte nicht entfernt werden',
  successfully_removed_attachment: 'Anhang erfolgreich entfernt',
  could_not_remove_task: 'Aufgabe konnte nicht entfernt werden',
  successfully_removed_task: 'Aufgabe erfolgreich entfernt',
  could_not_remove_section: 'Abschnitt konnte nicht entfernt werden',
  successfully_removed_section: 'Abschnitt erfolgreich entfernt',
  "default-academy-issuer": "Standard-Aussteller für Akademie-Zertifikate",
  "default-academy-issuer-hint": "Stellt die Zertifikate abgeschlossener Akademie-Kurse automatisch aus, außer der Teilnehmer hat bereits ein Zertifikat einer anderen im Kurs hinterlegten Zertifizierungsstelle. Es kann nur eine Standard-Stelle geben.",
  "academy-documents": "Akademiedokumente",
  "back-to-documents": "Zurück zu meinen Dokumenten",
  "completed-on": "Abgeschlossen am",
  "my-documents-academy": "Meine Akademiedokumente",
  'from-task': 'Von Aufgabe',
  "from-section": "Von Abschnitt",
  'no-documents-in-course': 'Keine Dokumente in diesem Kurs verfügbar',
  'unknown-course': 'Unbekannter Kurs',
  'error-loading-documents': 'Fehler beim Laden der Dokumente',
}
